import { css } from "@compiled/react";
import { useLocalizedHref } from "@libraries/web-framework";

import AccountCreation, { Social } from "@/components/signup/account-creation";
import {
    getWacIntegrationUrl,
    hasJiraImcCampaignKey,
    JIRA_PLUS_PAID_PARAM,
    JIRA_PLUS_PAID_VALUE,
    SocialProvider
} from "@/components/signup/utils";
import { useUserContext } from "@/components/user-context";
import { wacToken } from "@/libraries/design/foundations";
import { EnrollmentType, experiments, useExperiment } from "@/utils/experiment";

export type SignUpFormTextColor = "default" | "light";

export type UniformSignUpProps = {
    socialProviders?: SocialProvider[];
    textColor?: SignUpFormTextColor;
};

export const transformProviders = (providerList: string[]) => {
    return providerList.reduce(
        (previous, key) => ({ ...previous, [key.toLowerCase()]: key }),
        {}
    );
};

const lightTextColorCss = css({
    color: wacToken("color.neutral.light0")
});

const UniformSignUpForm = ({
    socialProviders,
    textColor = "default"
}: UniformSignUpProps) => {
    const jiraPlusExperiment = useExperiment(experiments.twcg1444JiraPlusOptIn);
    const jiraPlusPaidExperiment = useExperiment(
        experiments.twcg1444JiraPlusOptInPaid
    );
    const { utmCampaign } = useUserContext();
    const hasImcKey = hasJiraImcCampaignKey(utmCampaign);

    const jiraPlusPage = useLocalizedHref("/software/jira/free");

    const getContinueUrl: () => string | undefined = () => {
        if (hasImcKey) {
            if (jiraPlusPaidExperiment.type === EnrollmentType.ENROLLED) {
                jiraPlusPaidExperiment.fireExposure();
                if (jiraPlusPaidExperiment.value) {
                    return `${getWacIntegrationUrl()}${jiraPlusPage}?${JIRA_PLUS_PAID_PARAM}=${JIRA_PLUS_PAID_VALUE}`;
                }
            }
        } else {
            if (jiraPlusExperiment.type === EnrollmentType.ENROLLED) {
                jiraPlusExperiment.fireExposure();
                if (jiraPlusExperiment.value) {
                    return `${getWacIntegrationUrl()}${jiraPlusPage}`;
                }
            }
        }
    };

    return (
        <div css={[textColor === "light" && lightTextColorCss]}>
            <AccountCreation
                getContinueUrl={getContinueUrl}
                Login={null}
                Social={
                    socialProviders?.length ? (
                        <Social
                            providers={transformProviders(socialProviders)}
                        />
                    ) : undefined
                }
            />
        </div>
    );
};

export default UniformSignUpForm;
